import React from 'react';
import PropTypes from 'prop-types';

import CommonActionCallout from 'dpl/prismic/components/ActionCallout';

import { ARTICLE_CONTENT_COL_CLASSES } from '../utils/constants';

export default function ActionCallout({ sliceData }) {
  return (
    <div className="PrismicArticleActionCallout container">
      <div className="row">
        <div className={ARTICLE_CONTENT_COL_CLASSES}>
          <CommonActionCallout sliceData={sliceData} />
        </div>
      </div>
    </div>
  );
}
ActionCallout.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  sliceData: PropTypes.object.isRequired
};
